import React, { Component } from 'react'
import { toastContainer } from '../../utils/toast'
import { isMobile } from '../../utils/deviceInfo'
import './trivia-survey.css'
import './trivvy-list-bwai.css'
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
  ModalHeader,
  Label,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  Badge,
} from 'reactstrap'
import { connect } from 'react-redux'
import moment from 'moment'
import { GiBigGear, GiOpenTreasureChest } from 'react-icons/gi'
import { CSVLink } from 'react-csv'
import axios from '../../axios'
import * as url from '../../utils/url'
import * as actionCreators from '../../modules/actions/index'
import Loading from '../../hoc/Loading/Loading'
import { AiFillCloseCircle } from 'react-icons/ai'
import { MdFileUpload } from 'react-icons/md'
import { FaArrowRight } from 'react-icons/fa6'
import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
  LayoutHeadingLines,
  LayoutDataLines,
  LayoutRowLines,
  LayoutRow,
} from '../../components/TableComponents/RowCardShadow/RowCardShadow'

import {
  formatDuration,
  getSentScheduledDate,
  sortTrivvyList,
  isServerSortedKey,
  hasQuestions,
  hasResponseRate,
  getResponseRate,
  getResponsesCountSurvey,
  getSentCount,
  isTrivvyOfNonMcq,
  isNonKcTrivvy,
  getTrivvyRating,
  isTrivvyGeneratedFromCustomTemplates,
  SURVEY_LIST,
  WEB_GENERATE_ERROR_MESSAGE,
  canEditTrivvyPrivacy,
  getTrivvyTitleText,
} from './data'
import ReactTooltip from 'react-tooltip'
import If from '../../components/Shared/If'
import { SURVEY_QUESTIONS } from '../../components/Survey/data'
import {
  BiDotsHorizontal,
  BiDownArrowAlt,
  BiEditAlt,
  BiNotepad,
  BiUpArrowAlt,
  BiX,
} from 'react-icons/bi'
import { BsDownload, BsGearFill, BsThreeDots } from 'react-icons/bs'
import { LuFolderPlus, LuFileText, LuDownload } from 'react-icons/lu'
import RenamePopup from './Components/RenamePopup'
import SentScheduledCell from './Components/SentScheduledCell'
import ListLoadingRow from './Components/ListLoadingRow'
import DeleteTriviaPopup from './Components/DeleteTriviaPopup'
import CreateSurveyPopup from './Components/CreateTrivia/CreateTriviaPopup'
import RewardCreateModal from './Components/RewardCreateModal'

import EmptyTable from '../../components/EmptyTable/EmptyTable'
import {
  baseUrl,
  Spinner,
  triviaListCategories,
  TRIVVY_LIST_COLUMN_LABELS,
} from '../../utils/constants'
import BottomScrollListener from 'react-bottom-scroll-listener'
import UploadUsersModal from './Components/UploadUsersModal'
import ResponsePurchaseModal from './Components/ResponsePurchaseModal'
import TrivvyResponseCounter from './Components/TrivvyResponseCounter'
import ApplyPurchaseToTrivvy from './Components/ApplyPurchaseToTrivvyModal'
import DuplicateTriviaPopup from './Components/DuplicateTriviaPopup'
import TrivvyImmediateRewardToast from '../../components/TrivvyToast/TrivvyImmediateRewardToast'
import CreateTriviaModalMain, {
  TRIVVY_TYPE_BUILT_WITH_AI,
} from './Components/CreateTrivia/CreateTriviaModalMain'
import TrivvyLinkedRewardsDetailsModal from './Components/TrivvyLinkedRewardsDetailsModal'
import CheckBox from 'rc-checkbox'
import WarningModal from '../../components/Trivvy/WarningModal'
import ManualRemindersModal from './Components/ManualRemindersModal'
import UpdateTrivvyPrivacyModal from './Components/UpdateTrivvyPrivacyModal'
import TrivvyPrivacyTag from './Components/TrivvyPrivacyTag'
import { TiChartLine } from 'react-icons/ti'
import SurveySamplesPage from './SurveySamplesPage'
import LocalSearchBar from './Components/LocalSearchBar'
import FolderRow from './Components/FolderRow'
import FolderRowMobileLines from './Components/FolderRowMobileLines'
import FolderModals from './Components/FolderModals'
import FolderSubmenu from './Components/FolderSubmenu'
import * as folderService from './Components/folderService'
import { makeFolderHandlers } from './Components/folderWiring'
import ListRowIcon from './Components/ListRowIcon'

class TriviaList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rewardDescModalId: null,
      firstTimePopupText: '',
      uploadFileOpen: false,
      initialSelectedType: null,
      newGeneratedSurvey: [],
      surveyList: [],
      hoveredSurvey: null,
      optionsPopoverOpen: null,
      invidualItemAction: {
        type: null,
        item: null,
      },
      loadingCreateTrivia: false,
      currentPage: 1,
      listHasMore: true,
      uploadUsersModal: false,
      purchaseResponsesModal: false,
      responsePurchaseCallbackData: null,
      applyPurchaseModalData: null,
      applyPurchaseOpen: false,
      selectedTrivvys: [],
      selectedTrivvysWarningModal: {
        open: false,
        message: null,
      },
      surveySamplesModalOpen: false,
      // Folders
      folderList: [],
      folderMembership: {},
      activeFolder: null,
      draggingItemId: null,
      dragOverFolderId: null,
      folderNameModal: { open: false, mode: 'create', folder: null },
      selectTrivvysModalOpen: false,
      // Local search state (bug632). getVisibleItems() returns searchResults
      // while isSearchActive, so the shared displayList render shows them.
      searchQuery: '',
      searchResults: null,
      isSearchActive: false,
      searchCurrentPage: 1,
      searchHasMore: true,
      searchLoading: false,
      updatePrivacyModalOpen: false,
      privacyModalTrivvy: null,
      isSortReloading: false,
    }

    this.folder = makeFolderHandlers(this, {
      category: 'SURVEY',
      listKey: 'surveyList',
      selectedKey: 'selectedTrivvys',
      emptyTopText: 'No trivvys created',
      deletedItemsLabel: 'Trivvys',
      sortItems: (items) =>
        sortTrivvyList(
          items,
          this.props.sortParams.sortBy,
          this.props.sortParams.sortOrder,
          'surveys'
        ),
    })
  }

  // Reset generation: bumped only when the list is rebuilt from page 1, so a
  // superseded reset is dropped while sequential paging never cancels itself.
  listResetToken = 0

  // Open list fetches; a bottom scroll only pages when this is zero.
  listFetchesInFlight = 0

  // A sort reset a folder / search deferred, drained on the way back to the list.
  listResetPending = false

  // 6539c18cc96ae27405744df6
  componentDidMount() {
    const { organizationId } = this.props.user.profile

    if (this.props.showCreatePopup) {
      this.setState({
        uploadFileOpen: true,
        initialSelectedType: null,
        firstTimePopupText:
          this.props.user && this.props.user.profile
            ? `Welcome, ${this.props.user.profile.firstName} ${this.props.user.profile.lastName}. Let's create your first Trivvy. To start select one of the options below.`
            : '',
      })
    } else {
    }

    if (isMobile) {
      this.props.updateNavBar({
        title: 'Trivvy',
        hasBack: true,
        backButton: '<b>Back</b>',
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      })
    } else {
    }

    let that = this

    //axios.get(url.findOrgById(organizationId._id)).then(({ data }) => {
    //  const payload = data.data;
    //  that.props.orgChangeSuccess(payload);
    //});

    if (!this.props.showTrivvyListOnly) {
      this.retrieveSurveys(1, null, true)
      this.folder.loadFolders()
    }

    this.props.setCurrentTrivia(null)

    // const queyParams = new URLSearchParams(window.location.search);

    // const stripe_session_id = queyParams.get("session_id");
    // const response_purchase_id = queyParams.get("responsePurchaseId");

    // if (stripe_session_id && response_purchase_id) {
    //   axios
    //     .get(url.getStripeSessionStatus(stripe_session_id))
    //     .then(({ data }) => {
    //       const result = data.data;

    //       if (result.status == "complete") {
    //         axios
    //           .get(url.handlePurchaseSuccess(response_purchase_id))
    //           .then(({ data }) => {
    //             const result = data.data;

    //             this.props.orgChangeSuccess(result.org);

    //             this.setState({
    //               purchaseResponsesModal: true,
    //               responsePurchaseCallbackData: {
    //                 success: true,
    //                 ...result.purchase,
    //               },
    //             });
    //           })
    //           .catch((err) => {
    //             toastContainer(
    //               "Error while increasing response limit",
    //               "error"
    //             );
    //             this.setState({
    //               purchaseResponsesModal: true,
    //               responsePurchaseCallbackData: {
    //                 success: false,
    //                 message:
    //                   "Your payment was succesfull but error occured while adding the purchsed responses limit for your organization.",
    //               },
    //             });
    //             console.log(err);
    //           });
    //       } else if (result.status == "open") {
    //         axios
    //           .get(url.handlePurchaseFailure(response_purchase_id))
    //           .then(({ data }) => {
    //             this.setState({
    //               purchaseResponsesModal: true,
    //               responsePurchaseCallbackData: {
    //                 success: false,
    //                 message: "Your payment has been failed, Please try again",
    //               },
    //             });
    //           })
    //           .catch((err) => {
    //             toastContainer("Failed payment", "error");
    //             console.log(err);
    //           });
    //       }
    //     })
    //     .catch((err) => {
    //       toastContainer("Error getting payment session", "error");
    //       console.log(err);
    //     });
    // }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.trivvyOpen != nextProps.trivvyOpen && nextProps.trivvyOpen) {
      this.setState({
        uploadFileOpen: true,
        initialSelectedType: null,
      })
    } else {
    }
    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      const nextSort = nextProps.sortParams
      const wasServerSorted = isServerSortedKey(
        'surveys',
        this.props.sortParams && this.props.sortParams.sortBy
      )
      const willBeServerSorted = isServerSortedKey('surveys', nextSort.sortBy)
      // Folder / search rows come from folderContents / searchResults, which the
      // sort never refetches — resetting surveyList there only empties the picker.
      const inFolderOrSearch =
        !!this.state.activeFolder || !!this.state.isSearchActive
      const needsListReset =
        !this.props.showTrivvyListOnly && (wasServerSorted || willBeServerSorted)
      if (needsListReset && !inFolderOrSearch) {
        // Server-sortedness changed (either direction): refetch from page 1, or
        // page 1 of sort A would stay concatenated with page 2 of sort B.
        this.resetSurveyList(nextSort)
      } else {
        // In a folder / search the reset is deferred, never dropped — the
        // accumulated window still holds the old sort until it is rebuilt.
        if (needsListReset) {
          this.listResetPending = true
        }
        this.handleSortChange(nextSort.sortBy, nextSort.sortOrder)
      }
      // A sort change releases the "just created" folder pin (TBV-726 item 4).
      this.folder.clearJustCreatedPin()
    }

    if (this.props.showTrivvyListOnly && this.props.trivvyListPrefetchedArray) {
      if (
        JSON.stringify(this.props.trivvyListPrefetchedArray) !==
        JSON.stringify(nextProps.trivvyListPrefetchedArray) &&
        nextProps.trivvyListPrefetchedArray &&
        nextProps.trivvyListPrefetchedArray.length
      ) {
        this.setState(
          { surveyList: nextProps.trivvyListPrefetchedArray },
          () => {
            this.props.updateSortParams({
              sortOrder: 'desc',
              sortBy: 'createdDate',
            })
          }
        )
      }
    }

    if (
      JSON.stringify(this.props.importTemplateAddedTrivvys) !==
      JSON.stringify(nextProps.importTemplateAddedTrivvys)
    ) {
      if (nextProps.importTemplateAddedTrivvys.length > 0) {
        this.setState({
          surveyList: [
            ...nextProps.importTemplateAddedTrivvys,
            ...this.state.surveyList,
          ],
        })
        this.props.setImportTemplateAddedTrivvys([])
      }
    }

    if (
      JSON.stringify(this.props.updateTrivvyLinkedRewards) !==
      JSON.stringify(nextProps.updateTrivvyLinkedRewards)
    ) {
      const updateDoc = nextProps.updateTrivvyLinkedRewards
      console.log('check 1 ---', updateDoc)
      const trivvysOld = [...this.state.surveyList]

      if (
        updateDoc.rewardId &&
        updateDoc.trivvyIds &&
        updateDoc.trivvyIds.length
      ) {
        for (const id of updateDoc.trivvyIds) {
          const triviaIndex = trivvysOld.findIndex((x) => x._id == id)

          console.log('check 2 ---', triviaIndex)

          if (triviaIndex >= 0) {
            let newDoc = { ...trivvysOld[triviaIndex] }

            newDoc.linkedRewards = [
              ...newDoc.linkedRewards,
              { itemId: updateDoc.rewardId },
            ]
            trivvysOld[triviaIndex] = newDoc

            console.log('check 3 ---', trivvysOld[triviaIndex])

            this.setState({
              surveyList: [...trivvysOld],
            })
          }
        }
      }
    }
  }

  handleTrivvyRowCheckboxClick = (value, id) => {
    const trivvys = [...this.state.selectedTrivvys]

    if (trivvys.includes(id)) {
      const newTrivvys = trivvys.filter((x) => x != id)
      this.setState({ selectedTrivvys: newTrivvys })
    } else {
      trivvys.push(id)
      this.setState({ selectedTrivvys: trivvys })
    }
  }

  handleSelectAllTrivvys = (value) => {
    if (value) {
      const allTrivvyIds = this.folder.getVisibleItems().map((item) => item._id)
      this.setState({ selectedTrivvys: allTrivvyIds })
    } else {
      this.setState({ selectedTrivvys: [] })
    }
  }

  handleBottomScroll = () => {
    if (this.props.showTrivvyListOnly) {
      return
    }
    // Only when the paged list is on screen: inside a folder this handler also
    // pages the "add existing" picker, which reads the very list a reset empties.
    if (!this.state.activeFolder && this.drainPendingListReset()) {
      return
    }
    if (this.state.listHasMore !== false && this.listFetchesInFlight === 0) {
      this.setState({ currentPage: this.state.currentPage + 1 }, () => {
        this.retrieveSurveys(this.state.currentPage)
      })
    }
  }

  // Start a new search. Resets pagination and fetches page 1.
  handleSearch = (query) => {
    this.setState(
      {
        searchQuery: query,
        searchResults: [],
        isSearchActive: true,
        searchCurrentPage: 1,
        searchHasMore: true,
      },
      () => {
        this.performSearchWithPagination(query, 1)
      }
    )
  }

  // Paginated search API call. Reuses the /get-trivia list endpoint with an
  // optional `search` param — the BE ANDs a name regex onto the same
  // condition the list uses, so results are guaranteed to match the list's
  // shape and filtering. triviaCategoryType="SURVEY" scopes the result set
  // to items visible on the Surveys tab.
  performSearchWithPagination = (query, page) => {
    const pageLimit = 20
    this.setState({ searchLoading: true })

    const params = {
      search: query,
      triviaCategoryType: 'SURVEY',
      page: page,
      perPage: pageLimit,
    }

    axios
      .get(url.getTriviaList, { params })
      // Two-arg form, not .catch: a throw inside the success handler would
      // otherwise decrement the in-flight counter twice and wedge paging.
      .then(({ data }) => {
        const results = data && data.data && data.data.surveys ? data.data.surveys : []

        this.setState((prevState) => ({
          searchResults:
            page === 1 ? results : [...(prevState.searchResults || []), ...results],
          searchLoading: false,
          searchHasMore: results.length === pageLimit,
        }))
      })
      .catch((err) => {
        console.error('Error fetching survey search results:', err)
        this.setState({
          searchLoading: false,
          searchHasMore: false,
        })
      })
  }

  // Paginate the search when the user scrolls to the bottom while search is
  // active. Guards prevent duplicate requests in flight.
  handleSearchScrollBottom = () => {
    const { searchHasMore, searchLoading, searchCurrentPage, searchQuery, isSearchActive } = this.state

    if (isSearchActive && searchHasMore && !searchLoading) {
      const nextPage = searchCurrentPage + 1
      this.setState({ searchCurrentPage: nextPage }, () => {
        this.performSearchWithPagination(searchQuery, nextPage)
      })
    }
  }

  // Return to the full list view.
  handleClearSearch = () => {
    this.setState(
      {
        searchResults: null,
        searchQuery: '',
        isSearchActive: false,
        searchCurrentPage: 1,
        searchHasMore: true,
        searchLoading: false,
      },
      () => {
        this.drainPendingListReset()
      }
    )
  }

  // Source of truth for the rendered list: search results when active, else
  // the full surveyList.
  getFilteredList = () => {
    const { surveyList, searchResults, isSearchActive } = this.state
    if (isSearchActive && searchResults !== null) {
      return searchResults
    }
    return surveyList
  }

  handlePrivacyUpdated = (trivvyId, visibility) => {
    this.setState({
      surveyList: this.state.surveyList.map((s) =>
        s._id === trivvyId ? { ...s, adminVisibility: visibility } : s
      ),
    })
  }

  // Rebuild the list from page 1 under `sortOverride`, or the current sort when
  // it is omitted. Bumping the token invalidates any page fetch still in flight.
  resetSurveyList = (sortOverride) => {
    this.listResetToken = this.listResetToken + 1
    // surveyList is kept because the CSV export reads it; the rows hide behind
    // isSortReloading instead, which leaves the export button mounted.
    this.setState(
      {
        currentPage: 1,
        listHasMore: true,
        selectedTrivvys: [],
        // Blanks the rows behind a spinner: the old ones are in the OLD order,
        // and rendering them reads as a wrong result until page 1 lands.
        isSortReloading: true,
      },
      () => {
        this.retrieveSurveys(1, sortOverride)
      }
    )
  }

  // Run a sort reset that a folder / search deferred. True when one was pending.
  drainPendingListReset = () => {
    if (!this.listResetPending) {
      return false
    }
    this.listResetPending = false
    this.resetSurveyList()
    return true
  }

  retrieveSurveys = (page, sortOverride, isInitialLoad) => {
    const sortParams = sortOverride || this.props.sortParams
    const perPage = 20
    const params = { page, perPage, triviaCategoryType: 'SURVEY' }
    // Opt-in: only the columns the BE can sort globally travel with the request,
    // so page 1 holds the real top-20 instead of a createdOn-chosen prefix.
    if (isServerSortedKey('surveys', sortParams.sortBy)) {
      params.sortBy = sortParams.sortBy
      params.sortOrder = sortParams.sortOrder === 'desc' ? 'desc' : 'asc'
    }
    const requestToken = this.listResetToken
    this.listFetchesInFlight = this.listFetchesInFlight + 1
    axios
      .get(url.getTriviaList, { params })
      // Two-arg form, not .catch: a throw inside the success handler would
      // otherwise decrement the in-flight counter twice and wedge paging.
      .then(({ data }) => {
        this.listFetchesInFlight = this.listFetchesInFlight - 1
        // A newer reset (sort toggle / deferred drain) already owns the list.
        if (requestToken !== this.listResetToken) {
          return
        }
        const payload = (data && data.data) || {}
        const surveys = payload.surveys || []
        // An un-deployed BE sends no hasMore; a full page still means "keep going".
        const hasMore =
          typeof payload.hasMore === 'boolean'
            ? payload.hasMore
            : surveys.length === perPage
        if (surveys && surveys.length == 0 && page <= 1) {
          // Survey Samples modal should only open via button click,
          // not automatically on empty survey list
        }
        this.setState(
          {
            surveyList:
              page <= 1 ? surveys : [...this.state.surveyList, ...surveys],
            listHasMore: hasMore,
            isSortReloading: false,
          },
          () => {
            this.handleSortChange(sortParams.sortBy, sortParams.sortOrder)
          }
        )
      }, (err) => {
        this.listFetchesInFlight = this.listFetchesInFlight - 1
        // Token-guarded: a superseded request must not clear the spinner out
        // from under the reset that replaced it.
        if (requestToken === this.listResetToken) {
          this.setState({ isSortReloading: false })
        }
        console.log(err)
      })
  }

  handleFileUpload = (e) => {
    this.setState({
      uploadedFile: e.target.files[0],
    })
  }

  isValidURL = (url) => {
    const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(:[0-9]+)?(\/[^\s]*)?$/
    return urlPattern.test(url)
  }

  getSurveyName = () => {
    const { fileUrl, uploadedFile } = this.state
    if (uploadedFile) {
      return uploadedFile.name.split('.')[0]
    } else {
      return 'Survey - ' + moment().format('DD MMM , YYYY')
    }
  }

  handleSortChange = (key, order) => {
    this.setState({
      surveyList: sortTrivvyList(this.state.surveyList, key, order, 'surveys'),
    })
  }

  sortComponent = (key) => {
    const { sortParams } = this.props
    // console.log('key --- ', key)
    if (JSON.stringify(sortParams.sortBy) === JSON.stringify(key)) {
      if (sortParams.sortOrder === 'desc') {
        return (
          <BiDownArrowAlt
            size={'13px'}
            onClick={() => this.changeSortField(key, 'asc')}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        )
      } else {
        return (
          <BiUpArrowAlt
            size={'13px'}
            onClick={() => this.changeSortField(key, 'desc')}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        )
      }
    } else {
      return (
        <BiUpArrowAlt
          size={'13px'}
          onClick={() => this.changeSortField(key, 'desc')}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      )
    }
  }

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    })
  }

  redirectToSurveyPage = (survey) => {
    // this.props.setCurrentTrivia(survey);
    const { organizationId } = this.props.user.profile
    if (!survey.isPublished) {
      // the edit page is hidden on mobile, so unpublished trivvys open the
      // Share page there instead. Desktop keeps going to Edit.
      const unpublishedTarget = isMobile ? "share" : "edit";
      this.props.history.push(
        `/home/trivia/${organizationId._id}/edit/${survey._id}/${unpublishedTarget}`
      )
    } else if (survey.totalSubmissions > 0) {
      this.props.history.push(
        `/home/trivia/${organizationId._id}/edit/${survey._id}/results`
      )
    } else {
      this.props.history.push(
        `/home/trivia/${organizationId._id}/edit/${survey._id}/share`
      )
    }
  }

  openApplyPurchaseModal = (data) => {
    this.setState({ applyPurchaseOpen: true, applyPurchaseModalData: data })
  }
  closeApplyPurchaseModal = (data) => {
    this.setState({ applyPurchaseOpen: false, applyPurchaseModalData: null })
  }

  handleDropdownAction = (actionType, item) => {
    this.setState({ optionsPopoverOpen: null })
    if (actionType === 'REMIND') {
      this.setState({
        invidualItemAction: {
          type: 'REMIND',
          item: item,
        },
      })
    }
    if (actionType === 'OPEN') {
      this.redirectToSurveyPage(item)
    }
    if (actionType === 'END') {
      axios
        .put(url.editTrivia(item._id), {
          updateData: { trivvyEndDate: moment().startOf("day") },
        })
        .then((data) => {
          const updated = {
            ...item,
            trivvyEndDate: moment().startOf("day"),
          }
          this.onUpdateItem(updated)
          toastContainer('Trivvy ended successfully', 'success')
        })
        .catch((err) => {
          console.log(err)
          toastContainer('Error ending Trivvy', 'error')
        })
    }
    if (actionType === 'RENAME') {
      this.setState({
        invidualItemAction: {
          type: 'RENAME',
          item: item,
        },
      })
    }
    if (actionType === 'PURCHASE') {
      this.openApplyPurchaseModal(item)
    }

    if (actionType === 'DUPLICATE') {
      this.setState({
        invidualItemAction: {
          type: 'DUPLICATE',
          item: item,
        },
      })
    }

    if (actionType === 'COPY') {
      navigator.clipboard.writeText(
        `${baseUrl()}home/trivia/${item.organizationId}/quiz/${item._id}/start`
      )
    }
    if (actionType === 'DELETE') {
      this.setState({
        invidualItemAction: {
          type: 'DELETE',
          item: item,
        },
      })
    }

    if (actionType === 'PUBLISH') {
      axios
        .put(url.updateTrivvyPublish(item._id), {
          updateData: { isPublished: !item.isPublished },
        })
        .then((data) => {
          const updated = {
            ...item,
            isPublished: !item.isPublished,
          }

          this.onUpdateItem(updated)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }

  closeInvidualItemAction = () => {
    this.setState({
      invidualItemAction: {
        type: null,
        item: null,
      },
    })
  }

  renderRowOptions = (item) => {
    const { optionsPopoverOpen } = this.state
    const { isAdmin } = this.props
    if (item && item._id && isAdmin) {
      return (
        <div className="cursor-pointer">
          <span
            id={`surveyListRow_${item._id}`}
            onClick={() => this.setState({ optionsPopoverOpen: item._id })}
            className="cursor-pointer">
            <BsThreeDots />
          </span>

          <Popover
            isOpen={optionsPopoverOpen == item._id}
            target={`surveyListRow_${item._id}`}
            toggle={() => this.setState({ optionsPopoverOpen: null })}
            placement="bottom"
            modifiers={{
              flip: { boundariesElement: 'viewport' },
              preventOverflow: { boundariesElement: 'viewport' },
            }}
            hideArrow
            className="surveyListRow_Popover">
            <PopoverBody className="">
              {/* the edit page is hidden on mobile, so drop its 3-dots option there. */}
              {!isMobile && (
                <div
                 className={`${item.isPublished && item.totalSubmissions > 0 ? 'disabled-dropdown-item' : 'cursor-pointer'} dropdown-item my-1`}
                style={{
                      pointerEvents: item.isPublished && item.totalSubmissions > 0 ? 'none' : 'auto',
                  }}
                  onClick={() => {
                    this.handleDropdownAction('OPEN', item)
                  }}>
                  Edit
                </div>
              )}

              <div
                className={`${item.trivvyEndDate ? 'disabled-dropdown-item' : 'cursor-pointer'} dropdown-item my-1`}
                style={{
                    pointerEvents: item.trivvyEndDate ? 'none' : 'auto',
                }}
                onClick={() => {
                  this.handleDropdownAction('END', item)
                }}>
                End
              </div>

              <div
                className={`${item.isPublished && item.totalSubmissions > 0 ? 'disabled-dropdown-item' : 'cursor-pointer'} dropdown-item my-1`}
                onClick={() => {
                  if (!(item.isPublished && item.totalSubmissions > 0)) {
                    this.handleDropdownAction('PUBLISH', item)
                  }
                }}>
                {item.isPublished ? 'Un-Publish' : 'Publish'}
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('RENAME', item)
                }}>
                Rename
              </div>

              {item.isPublished &&
                item.sharedWithUsers &&
                item.sharedWithUsers.length ? (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.handleDropdownAction('REMIND', item)
                  }}>
                  Remind users
                </div>
              ) : (
                ''
              )}

              <div
                className="dropdown-item cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('DUPLICATE', item)
                }}>
                Duplicate
              </div>
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('COPY', item)
                }}>
                Copy Link
              </div>

              {canEditTrivvyPrivacy(item, this.props.user.profile) && (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.setState({
                      updatePrivacyModalOpen: true,
                      privacyModalTrivvy: item,
                      optionsPopoverOpen: null,
                    })
                  }}>
                  Update Privacy
                </div>
              )}

              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.handleDropdownAction('DELETE', item)
                }}>
                Delete
              </div>

              {this.state.activeFolder ? (
                <React.Fragment>
                  <div
                    className="dropdown-item my-1 cursor-pointer"
                    onClick={() => {
                      this.folder.handleRemoveItemFromFolder(item._id)
                    }}>
                    Remove from Folder
                  </div>
                  {this.state.folderList.length > 1 && (
                    <FolderSubmenu
                      mode="move"
                      folders={this.state.folderList}
                      membership={this.state.folderMembership}
                      itemNoun={folderService.getFolderNoun(this.folder.category)}
                      currentFolderId={this.state.activeFolder._id}
                      memberFolderIds={item.folderId ? [String(item.folderId)] : []}
                      onSelect={(fid) =>
                        this.folder.moveItemToFolder(item, fid, true)
                      }
                      onCreateNew={() => this.folder.createFolderForItem(item)}
                    />
                  )}
                </React.Fragment>
              ) : (
                this.state.folderList.length > 0 && (
                  <FolderSubmenu
                    mode="add"
                    folders={this.state.folderList}
                    membership={this.state.folderMembership}
                    itemNoun={folderService.getFolderNoun(this.folder.category)}
                    currentFolderId={null}
                    memberFolderIds={item.folderId ? [String(item.folderId)] : []}
                    onSelect={(fid) =>
                      this.folder.moveItemToFolder(item, fid, false)
                    }
                    onCreateNew={() => this.folder.createFolderForItem(item)}
                  />
                )
              )}

              {item.waitingCount > 0 && (
                <div
                  className="dropdown-item my-1 cursor-pointer"
                  onClick={() => {
                    this.handleDropdownAction('PURCHASE', item)
                  }}>
                  Manage Purchase
                </div>
              )}
            </PopoverBody>
          </Popover>
        </div>
      )
    } else {
      return null
    }
  }

  onDeleteItem = (id) => {
    const { surveyList } = this.state
    const docs = [...surveyList]

    const newDocs = docs.filter((x) => x._id != id)

    this.setState({ surveyList: newDocs })

    // Drop it from the open folder's view too when deleted from inside a folder.
    this.folder.removeFolderItem(id)

    this.closeInvidualItemAction()

    if (this.props.onDeleteFromLibList) {
      this.props.onDeleteFromLibList()
    }
  }

  onUpdateItem = (updated) => {
    const { surveyList } = this.state
    let docs = [...surveyList]

    const itemIndex = docs.findIndex((x) => x._id == updated._id)
    if (itemIndex >= 0) {
      docs[itemIndex] = updated

      this.setState({ surveyList: docs })
    }

    // Keep the open folder's view in sync when the action was taken from inside
    // a folder (publish, end, rename) — patches folderContents in place.
    this.folder.patchFolderItem(updated)

    this.closeInvidualItemAction()
  }

  addTrivvySuccessFromTemplates = (newData) => {
    this.props.setCreateModalState(false)
    this.setState({
      surveyList: [...newData, ...this.state.surveyList],
      templateModalOpen: false,
    })
  }

  handleAfterAddTrivia = (newSurvey) => {
    this.props.setCreateModalState(false)
    if (newSurvey.triviaType == 2 || newSurvey.duplicatedFromTrivvy) {
      const surveys = [...this.state.surveyList]
      surveys.unshift(newSurvey)
      this.setState({
        surveyList: [...surveys],
        uploadFileOpen: false,
      })
      if (this.props.setTrivvyOpen) {
        this.props.setTrivvyOpen(false)
      }

      if (newSurvey) {
        if (newSurvey.isMessaging) {
          this.props.history.push(
            `/home/trivia/${newSurvey.organizationId}/edit/${newSurvey._id}/share`
          )
        } else {
          this.props.history.push(
            `/home/trivia/${newSurvey.organizationId}/edit/${newSurvey._id}/edit`
          )
        }
      }
    } else {
      const surveys = [...this.state.surveyList]

      surveys.unshift(newSurvey)

      this.setState(
        {
          surveyList: [...surveys],
          uploadFileOpen: false,
          loadingCreateTrivia: true,
        },
        () => {
          if (this.props.setTrivvyOpen) {
            this.props.setTrivvyOpen(false)
          }
          this.setState({ newGeneratedSurvey: newSurvey })
        }
      )

      axios
        .post(url.generateTriviaQuestions, {
          trivia: newSurvey,
          noLoader: true,
        })
        .then(({ data }) => {
          const updatedSurvey = data.data.trivia
          const existingIndex = surveys.findIndex(
            (x) => x._id === updatedSurvey._id
          )
          if (existingIndex >= 0) {
            surveys[existingIndex] = updatedSurvey

            this.setState(
              {
                surveyList: [...surveys],
                loadingCreateTrivia: false,
              },
              () => {
                this.setState({ newGeneratedSurvey: [] })
                // toastContainer("Questions generated successfully", "success");
                toastContainer(
                  <TrivvyImmediateRewardToast
                    history={this.props.history}
                    trivvyIds={[newSurvey._id]}
                    noPlanCustomMessage={'Questions generated successfully'}
                  />,
                  'success'
                )
              }
            )
          }
        })
        .catch((error) => {
          surveys.shift()
          this.setState({
            newGeneratedSurvey: [],
            loadingCreateTrivia: false,
            surveyList: [...surveys],
          })
          let errorMsg = WEB_GENERATE_ERROR_MESSAGE
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message == 'ad_blocker'
          ) {
            errorMsg =
              'Sorry, we could not process this because there is a blocker on this website. Please save and upload as a PDF or copy and paste the text.'
          }
          toastContainer(errorMsg, 'error')

          console.log(error)
        })
    }
  }

  onTrivvyMultiGenerate = (payload, apiData) => {
    const surveys = [...payload.partsArray, ...this.state.surveyList]
    this.setState(
      {
        surveyList: [...surveys],
        uploadFileOpen: false,
        loadingCreateTrivia: true,
      },
      () => {
        if (this.props.setTrivvyOpen) {
          this.props.setTrivvyOpen(false)
        }
        this.setState({
          newGeneratedSurvey: payload.partsArray.map((x) => x.name),
        })
      }
    )

    axios
      .post(url.createOrScheduleMultipleTrivvys, apiData)
      .then(({ data }) => {
        const surveys = [...this.state.surveyList].filter((x) => x._id)

        this.setState({
          surveyList: [...data.data, ...surveys],
          newGeneratedSurvey: [],
          loadingCreateTrivia: false,
        })

        for (const item of data.data) {
          if (item.isPublished) {
            axios.put(url.shareTrivia(item._id), {
              sharedWithUsers: item.sharedWithUsers,
              privacy: item.privacy,
              shareTrivvyViaSMS: item.shareTrivvyViaSMS,
              shareTrivvyViaEmail: item.shareTrivvyViaEmail,
            })
          }
        }

        toastContainer(
          <TrivvyImmediateRewardToast
            history={this.props.history}
            trivvyIds={data.data.map((x) => x._id)}
            noPlanCustomMessage={'Questions generated successfully'}
          />,
          'success'
        )
      })
      .catch((error) => {
        surveys.shift()
        this.setState({
          newGeneratedSurvey: [],
          loadingCreateTrivia: false,
          surveyList: [...surveys],
        })
        let errorMsg = WEB_GENERATE_ERROR_MESSAGE
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message == 'ad_blocker'
        ) {
          errorMsg =
            'Sorry, we could not process this because there is a blocker on this website. Please save and upload as a PDF or copy and paste the text.'
        }
        toastContainer(errorMsg, 'error')

        console.log(error)
      })
  }

  getDataForExportResult = () => {
    const { surveyList } = this.state

    if (surveyList && surveyList.length) {
      const newList = surveyList.map((item) => ({
        name: getTrivvyTitleText(item) || 'NA',
        totalQuestions: item.questions ? item.questions.length : 0,
        averageScore: isTrivvyGeneratedFromCustomTemplates(item) || this.isTrivvyOfNonMcq(item)
          ? 'N/A'
          : item.totalSubmissions > 0
            ? `${Math.round(item.averageScore)}%`
            : 'N/A',
        averageTime: `${Math.round(item.averageTime || 0)} sec`,
        source:
          item.uploadType == 0
            ? 'Webpage'
            : item.uploadType == 1
              ? 'Document'
              : 'Custom Text',
        publishStatus: item.isPublished
          ? !moment(item.trivvyEndDate).isSameOrBefore(moment(), 'day') ||
            item.trivvyEndDate == null ||
            !item.trivvyEndDate
            ? 'Published'
            : 'Ended'
          : 'NotPublished',
        createdOn: item.createdOn
          ? moment(item.createdOn).format('h:mma on MMM D, YYYY')
          : 'NA',
        sentScheduled: (function() {
          const sentSched = getSentScheduledDate(item)
          return sentSched ? moment(sentSched).format('h:mma on MMM D, YYYY') : 'NA'
        })(),
        totalSubmissions: item.totalSubmissions || 0,
        responseRate: (function() {
          const denominator = (item.insightsTotalCount && item.insightsTotalCount > 0)
            ? item.insightsTotalCount
            : item.otherMediumsShareCount
          if (!denominator || denominator === 0) return 'N/A'
          const rate = Math.round((item.totalSubmissions / denominator) * 100)
          return rate + '%'
        })(),
        needsAttention: item.needsAttentionCount || 0,
      }))

      return newList
    } else {
      return []
    }
  }

  addTrivvySuccessFromTemplates = (data) => {
    if (this.props.setImportTemplateAddedTrivvys) {
      this.props.setImportTemplateAddedTrivvys(data)
      this.setState({
        uploadFileOpen: false,
      })
      if (this.props.setTrivvyOpen) {
        this.props.setTrivvyOpen(false)
      }
    }
  }

  goToRewards = () => {
    this.setState({
      uploadFileOpen: false,
    })
    if (this.props.setTrivvyOpen) {
      this.props.setTrivvyOpen(false)
    }
    this.props.handleGlobalRewardModal({
      open: true,
      trivvys: [],
    })
  }

  handleMultiplePublishUnPublish = (flag) => {
    axios
      .post(url.updateTrivvyPublishMultiple, {
        updateData: { isPublished: flag },
        trivvysToUpdate: this.state.selectedTrivvys,
      })
      .then((data) => {
        const updatedTrivias = data.data.data.trivias

        this.setState({
          selectedTrivvys: [],
        })

        for (const itm of updatedTrivias) {
          this.onUpdateItem(itm)
        }

        toastContainer('Updated succesfully', 'success')
        this.setState({ selectedTrivvys: [] })
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error occured while updating', 'error')
      })
  }

  handleMultipleDelete = () => {
    axios
      .post(url.deleteMultipleTrivias, {
        trivvysToDelete: this.state.selectedTrivvys,
      })
      .then((data) => {
        const deletedIds = this.state.selectedTrivvys

        const filtered = [...this.state.surveyList].filter(
          (x) => !deletedIds.includes(x._id)
        )

        this.setState({
          surveyList: [...filtered],
        })

        // Refresh the open folder's contents so a bulk delete inside a folder
        // drops the removed rows from the folder view.
        this.folder.reloadActiveFolder()

        toastContainer('Deleted succesfully', 'success')

        this.setState({ selectedTrivvys: [] })
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error occured while deleting trivvys', 'error')
      })
  }

  handleMultipleEnd = () => {
    axios
      .post(url.updateTrivvyEndDateMultiple, {
        trivvysToUpdate: this.state.selectedTrivvys,
        trivvyEndDate: moment().startOf("day"),
      })
      .then(({ data }) => {
        const updatedIds = this.state.selectedTrivvys
        const updatedList = [...this.state.surveyList].map((trivvy) => {
          if (updatedIds.includes(trivvy._id)) {
            return {
              ...trivvy,
              trivvyEndDate: moment().startOf("day"),
            }
          }
          return trivvy
        })

        this.setState({
          surveyList: updatedList,
          selectedTrivvys: [],
        })

        // Refresh the open folder's contents so a bulk end inside a folder shows
        // the new status on those rows.
        this.folder.reloadActiveFolder()

        toastContainer(
          `Successfully ended Trivvys`,
          'success'
        )
      })
      .catch((err) => {
        console.log(err)
        toastContainer('Error occurred while ending Trivvys', 'error')
      })
  }

  // Thin wrappers: the one definition lives in data.js so the cells and the
  // column sort can share it (TBV-853).
  isTrivvyOfNonMcq = (trivvy) => isTrivvyOfNonMcq(trivvy)

  isNonKcTrivvy = (trivvy) => isNonKcTrivvy(trivvy)

  render() {
    const orgObject = this.props.user.profile.organizationId
    const trivvy_plan_type = orgObject && orgObject.trivvyPlanType
    const {
      uploadFileOpen,
      uploadedFile,
      trivvyCatModal,
      fileUrl,
      surveyList,
      hoveredSurvey,
      invidualItemAction,
      newGeneratedSurvey,
      loadingCreateTrivia,
      uploadUsersModal,
      purchaseResponsesModal,
      applyPurchaseModalData,
      applyPurchaseOpen,
      preSelectedTriviaIds,
      rewardDescModalId,
      selectedTrivvys,
      selectedTrivvysWarningModal,
      surveySamplesModalOpen,
    } = this.state
    // TBV-845: the Name column gets one grid unit back (2 -> 3, i.e. 16.7% ->
    // 25%, matching Messages) so long Trivvy names have more room before they
    // truncate. The Bootstrap grid must total 12, so the unit is taken from
    // "Needs Attention" (scheduledOn), NOT from "Send Date" (createdOn) —
    // bug812 widened Send Date deliberately and that decision stands. Needs
    // Attention holds a short count, so its header wrapping to two lines
    // matches what "Response Rate" already does in this table.
    const tableCols = {
      name: 3,
      status: 1,
      createdOn: 2,
      questions: 1,
      sent: 1,
      responses: 1,
      responseRate: 1,
      scheduledOn: 1,
      action: 1,
    }

    const tableColsMobile = {
      status: 2,
      createdOn: 2,
      questions: 1,
      sent: 1,
      responses: 1,
      responseRate: 1,
      scheduledOn: 1,
      action: 1,
    }

    const { showTrivvyListOnly } = this.props

    const csv_headers = [
      {
        label: 'Trivvy Name',
        key: 'name',
      },
      {
        label: 'Total questions',
        key: 'totalQuestions',
      },
      // {
      //   label: 'Average Score',
      //   key: 'averageScore',
      // },
      // {
      //   label: 'Average Time',
      //   key: 'averageTime',
      // },
      {
        label: 'Source',
        key: 'source',
      },
      {
        label: 'Publish Status',
        key: 'publishStatus',
      },
      {
        label: 'Send Date',
        key: 'sentScheduled',
      },
      {
        label: 'End Date',
        key: 'trivvyEndDate',
      },
      {
        label: 'Responses',
        key: 'totalSubmissions',
      },
      {
        label: 'Response Rate',
        key: 'responseRate',
      },
      {
        label: 'Needs Attention',
        key: 'needsAttention',
      },
    ]

    const isAdmin =
      this.props.user.profile.orgAdmin ||
      this.props.user.profile.role == 'Admin'

    const {
      folderMembership,
      activeFolder,
      dragOverFolderId,
      folderNameModal,
      selectTrivvysModalOpen,
    } = this.state

    const {
      inFolderView,
      showFolders,
      sortedFolders,
      displayList,
      unfolderedCandidates,
      activeFolderCount,
      showEmptyMessage,
      emptyMessageText,
      isSortReloading,
    } = this.folder.getRenderState()

    return (
      <div id="triviaListPage" className="bwai-list bwai-list-surveys">
        {rewardDescModalId && rewardDescModalId.length > 0 ? (
          <TrivvyLinkedRewardsDetailsModal
            open={rewardDescModalId.length > 0}
            onClose={() =>
              this.setState({
                rewardDescModalId: null,
              })
            }
            trivvyId={rewardDescModalId}
          />
        ) : (
          ''
        )}
        {applyPurchaseOpen && applyPurchaseModalData ? (
          <ApplyPurchaseToTrivvy
            open={applyPurchaseOpen}
            onClose={this.closeApplyPurchaseModal}
            handleUpdateRow={this.onUpdateItem}
            trivia={applyPurchaseModalData}
          />
        ) : (
          ''
        )}
        {uploadFileOpen && (
          <CreateTriviaModalMain
            open={uploadFileOpen}
            initialSelectedType={this.state.initialSelectedType}
            onClose={() => {
              this.props.setCreateModalState(false)
              this.setState({
                uploadFileOpen: false,
                initialSelectedType: null,
              })
              if (this.props.setTrivvyOpen) {
                this.props.setTrivvyOpen(false)
              }
            }}
            setCreateModalState={this.props.setCreateModalState}
            onAddSuccess={this.handleAfterAddTrivia}
            user={this.props.user}
            addTrivvySuccessFromTemplates={this.addTrivvySuccessFromTemplates}
            firstTimePopupText={this.state.firstTimePopupText}
            goToRewards={this.goToRewards}
            canCreateRewards={surveyList && surveyList.length > 0}
            onTrivvyMultiGenerate={this.onTrivvyMultiGenerate}
          />
        )}

        {invidualItemAction &&
          invidualItemAction.type === 'RENAME' &&
          invidualItemAction.item ? (
          <RenamePopup
            onClose={() => {
              this.closeInvidualItemAction()
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === 'RENAME'}
            onUpdateItem={this.onUpdateItem}
          />
        ) : (
          ''
        )}

        <SurveySamplesPage
          open={surveySamplesModalOpen}
          onClose={() => this.setState({ surveySamplesModalOpen: false })}
          {...this.props}
        />

        <UpdateTrivvyPrivacyModal
          open={this.state.updatePrivacyModalOpen}
          trivvy={this.state.privacyModalTrivvy}
          onClose={() =>
            this.setState({
              updatePrivacyModalOpen: false,
              privacyModalTrivvy: null,
            })
          }
          onUpdateSuccess={this.handlePrivacyUpdated}
        />

        {invidualItemAction &&
          invidualItemAction.type === 'REMIND' &&
          invidualItemAction.item ? (
          <ManualRemindersModal
            open={invidualItemAction.type === 'REMIND'}
            triviaData={invidualItemAction.item}
            onClose={() => {
              this.closeInvidualItemAction()
            }}
          />
        ) : (
          ''
        )}

        {invidualItemAction &&
          invidualItemAction.type === 'DELETE' &&
          invidualItemAction.item ? (
          <DeleteTriviaPopup
            onClose={() => {
              this.closeInvidualItemAction()
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === 'DELETE'}
            onDeleteItem={this.onDeleteItem}
          />
        ) : (
          ''
        )}

        {invidualItemAction &&
          invidualItemAction.type === 'DUPLICATE' &&
          invidualItemAction.item ? (
          <DuplicateTriviaPopup
            onClose={() => {
              this.closeInvidualItemAction()
            }}
            item={this.state.invidualItemAction.item}
            open={this.state.invidualItemAction.type === 'DUPLICATE'}
            afterDuplicateSuccess={this.handleAfterAddTrivia}
          />
        ) : (
          ''
        )}

        {!showTrivvyListOnly && !inFolderView && (
          <div className="bwai-list-toolbar">
            {!isMobile && isAdmin && (
              <Button
                className="trivia-action-button-main mr-4 trivv-create-btn mt-2 create-trivvy-btn-itm"
                onClick={() => {
                  this.setState({
                    uploadFileOpen: true,
                    initialSelectedType: TRIVVY_TYPE_BUILT_WITH_AI,
                  })
                }}
                // color="success"
                size="sm"
                disabled={loadingCreateTrivia}>
                + Create Survey
              </Button>
            )}

            {!isMobile && isAdmin && (
              <Button
                className="trivia-action-button-main mr-4 trivv-create-btn mt-2 create-trivvy-btn-itm bwai-btn-secondary"
                onClick={this.folder.openFolderNameModalCreate}
                size="sm">
                <LuFolderPlus className="mr-1" size={14} /> New Folder
              </Button>
            )}

          {!isMobile && isAdmin &&
              <Button
                className="trivia-action-button-main add-reward-btn mr-4 mt-2 bwai-btn-secondary"
                onClick={() => {
                  this.setState({ surveySamplesModalOpen: true })
                }}>
                <LuFileText className="mr-1" size={14} /> Survey Samples
              </Button>
            }


            {isMobile && isAdmin && (
              <div className="mt-2 ml-2 d-flex align-items-center justify-content-start gap-3 bwai-mobile-toolbar-group">
                {/* Survey Samples + Trivvy creation are hidden on mobile; only
                    Export remains in the options dropdown. */}
                <UncontrolledDropdown direction="down">
                  <DropdownToggle className="trivia-action-button-main">
                    <GiBigGear /> Trivvy options
                  </DropdownToggle>
                  <DropdownMenu className="pt-2 pr-2 mt-2">
                    <DropdownItem
                      onClick={() => {
                        this.setState({
                          uploadFileOpen: true,
                          initialSelectedType: TRIVVY_TYPE_BUILT_WITH_AI,
                        })
                      }}
                      className="my-1">
                      Create Survey +
                    </DropdownItem>

                    <DropdownItem
                      onClick={this.folder.openFolderNameModalCreate}
                      className="my-1">
                      New Folder +
                    </DropdownItem>

                    <DropdownItem className="my-1">
                      <CSVLink
                        data={this.getDataForExportResult()}
                        headers={csv_headers}
                        filename={`Trivvys-${moment().format(
                          'MM/DD/YYYY'
                        )}.csv`}
                        separator={','}
                        target="_blank"
                        className="text-dark">
                        {'Export to CSV'} <BsDownload size={13} />
                      </CSVLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            )}

            {!isMobile && (
              <span className="bwai-toolbar-end">
                {' '}
                {surveyList && surveyList.length ? (
                  <CSVLink
                    data={this.getDataForExportResult()}
                    headers={csv_headers}
                    filename={`Trivvys-${moment().format('MM/DD/YYYY')}.csv`}
                    separator={','}
                    target="_blank"
                    className="mr-4 mt-2 btn trivia-action-button-main trivvy-list-export-mobile trivvy-export-table-btn bwai-btn-secondary">
                    <LuDownload className="mr-1" size={14} /> {'Export to CSV'}
                  </CSVLink>
                ) : (
                  ''
                )}{' '}
              </span>
            )}

    

            {uploadUsersModal && (
              <UploadUsersModal
                open={uploadUsersModal}
                onClose={() => {
                  this.setState({
                    uploadUsersModal: false,
                  })
                }}
              />
            )}
          </div>
        )}

        <FolderModals
          handlers={this.folder}
          deleteFolderModal={this.state.deleteFolderModal}
          inFolderView={inFolderView}
          activeFolder={activeFolder}
          activeFolderCount={activeFolderCount}
          isAdmin={isAdmin}
          folderNameModal={folderNameModal}
          selectTrivvysModalOpen={selectTrivvysModalOpen}
          folderMembership={folderMembership}
          unfolderedCandidates={unfolderedCandidates}
        />

        {selectedTrivvys && selectedTrivvys.length ? (
          <div
            className={
              isMobile
                ? 'mt-4 bwai-bulk-bar bwai-mobile-bulk-bar'
                : 'mt-4 bwai-bulk-bar'
            }>
            <b
              className="mx-2 text-success cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message:
                      'Are you sure you want to publish selected trivvys',
                    type: 'PUBLISH',
                  },
                })
              }}>
              Publish
            </b>
            <b
              className="mx-2 text-secondary cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message:
                      'Are you sure you want to unpublish selected trivvys',
                    type: 'UNPUBLISH',
                  },
                })
              }}>
              Unpublish
            </b>
            <b
              className="mx-2 text-danger cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message: 'Are you sure you want to delete selected trivvys',
                    type: 'DELETE',
                  },
                })
              }}>
              Delete
            </b>
            <b
              className="mx-2 text-warning cursor-pointer underline_txt mr-2"
              onClick={() => {
                this.setState({
                  selectedTrivvysWarningModal: {
                    open: true,
                    message: 'Are you sure you want to end selected Trivvys?',
                    type: 'END',
                  },
                })
              }}>
              End
            </b>

            <span>Selected trivvys ({selectedTrivvys.length})</span>
          </div>
        ) : (
          ''
        )}

        {selectedTrivvysWarningModal && selectedTrivvysWarningModal.open ? (
          <WarningModal
            open={selectedTrivvysWarningModal.open}
            message={selectedTrivvysWarningModal.message}
            type={selectedTrivvysWarningModal.type}
            onCancel={() => {
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
            onOk={() => {
              if (selectedTrivvysWarningModal.type === 'PUBLISH') {
                this.handleMultiplePublishUnPublish(true)
              } else if (selectedTrivvysWarningModal.type === 'UNPUBLISH') {
                this.handleMultiplePublishUnPublish(false)
              } else if (selectedTrivvysWarningModal.type === 'DELETE') {
                this.handleMultipleDelete()
              } else if (selectedTrivvysWarningModal.type === 'END') {
                this.handleMultipleEnd()
              }
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
            onClose={() => {
              this.setState({
                selectedTrivvysWarningModal: {
                  open: false,
                  message: '',
                  type: '',
                },
              })
            }}
          />
        ) : (
          ''
        )}

        {surveyList.length == -1 ? (
          <div className="d-flex justify-content-center">
            <EmptyTable
              title={'No trivias found'}
              subtitle={
                'You havent created any trivias yet. Please create from button above.'
              }
            />
          </div>
        ) : (
          <div>
            {/* Local search bar for the Surveys tab. Hits the
                /trivia/get-trivvy-search-keyword endpoint with
                source="SURVEY" so results are scoped to this tab and matched
                by name only. */}
            {!this.props.showTrivvyListOnly && !inFolderView && (
              <div
                className={isMobile ? 'mb-3 px-3 bwai-mobile-search' : 'my-3'}
                style={isMobile ? {} : { maxWidth: '500px' }}>
                <LocalSearchBar
                  onSearch={this.handleSearch}
                  onClearSearch={this.handleClearSearch}
                  isSearching={
                    this.state.searchLoading && this.state.searchCurrentPage === 1
                  }
                  placeholder="Search Surveys..."
                  mobilePlaceholder="Search Surveys..."
                />
              </div>
            )}
            {!isMobile ? (
              <div
              // style={{
              //   minWidth: "100%",
              //   maxWidth: "100%",
              //   overflowX: "auto",
              // }}
              // className="hide-scroll"
              >
                <div
                  className="trivia_survey_list_table"
                // style={{
                //   width: "1500px",
                // }}
                >
                  <div className="my-0">
                    <LayoutRowShadow className="row-shadow-header-no-shadow px-1em mx-0">
                      <LayoutHeadingShadowLeft
                        className={'text-left trivvy-name-col'}
                        colWidth={tableCols.name}>
                        {isAdmin && (
                          <CheckBox
                            checked={
                              displayList.length > 0 &&
                              selectedTrivvys.length === displayList.length
                            }
                            onChange={(e) =>
                              this.handleSelectAllTrivvys(e.target.checked)
                            }
                            className="mr-2"
                          />
                        )}
                        <span>Name {this.sortComponent('name')} </span>
                      </LayoutHeadingShadowLeft>

                      <If condition={true}>
                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.status}>
                          Status {this.sortComponent('status')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center '}
                          colWidth={tableCols.createdOn}>
                          Send Date {this.sortComponent('createdDate')}
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.questions}>
                          Questions {this.sortComponent('questionsCount')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center '}
                          colWidth={tableCols.sent}>
                          Sent {this.sortComponent('sent')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center '}
                          colWidth={tableCols.responses}>
                          Responses{' '}
                          {this.sortComponent('submissions')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center '}
                          colWidth={tableCols.responseRate}>
                          {TRIVVY_LIST_COLUMN_LABELS.RATE}{' '}
                          {this.sortComponent('responseRate')}
                        </LayoutHeadingShadow>
                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.scheduledOn}>
                          {TRIVVY_LIST_COLUMN_LABELS.ATTENTION}{' '}
                          {this.sortComponent('needsAttentionCount')}
                        </LayoutHeadingShadow>

                        <LayoutHeadingShadow
                          className={'justify-content-center'}
                          colWidth={tableCols.action}></LayoutHeadingShadow>
                      </If>
                    </LayoutRowShadow>
                    <BottomScrollListener
                      offset={100}
                      onBottom={
                        this.state.isSearchActive
                          ? this.handleSearchScrollBottom
                          : this.handleBottomScroll
                      }>
                      {(scrollRef) => (
                        <div
                          className={`trivia_survey_list_table_contents_scroll ${
                            this.getFilteredList().length == 0 ? '' : ''
                          }`}
                          ref={scrollRef}>
                          {showFolders &&
                            sortedFolders.map((folder) => (
                              <FolderRow
                                key={folder._id}
                                folder={folder}
                                itemCount={folderService.getFolderItemCount(
                                  folderMembership,
                                  folder._id
                                )}
                                itemNoun={folderService.getFolderNoun(
                                  this.folder.category
                                )}
                                nameColWidth={tableCols.name}
                                middleColWidths={[
                                  // One width per real column so the folder row's
                                  // dashes line up under their own headers.
                                  tableCols.status,
                                  tableCols.createdOn,
                                  tableCols.questions,
                                  tableCols.sent,
                                  tableCols.responses,
                                  tableCols.responseRate,
                                  tableCols.scheduledOn,
                                ]}
                                // Must mirror the class on each trivvy cell of THIS
                                // list, so the dashes inherit the same desktop
                                // padding-left nudges and line up with the rows
                                // below. Survey cells use the un-prefixed names
                                // (KCs use kc-*, Messages msg-*, Library lib-*).
                                middleColClasses={[
                                  'status-cell',
                                  'created-cell',
                                  'questions-cell',
                                  'sent-cell',
                                  'responses-cell',
                                  'response-rate-cell',
                                  'scheduled-cell',
                                ]}
                                actionColWidth={tableCols.action}
                                isAdmin={isAdmin}
                                isDragOver={dragOverFolderId === folder._id}
                                onOpen={() => this.folder.openFolder(folder)}
                                onDragOver={() =>
                                  this.folder.handleFolderDragOver(folder._id)
                                }
                                onDragLeave={() =>
                                  this.folder.handleFolderDragLeave(folder._id)
                                }
                                onDrop={() => this.folder.handleFolderDrop(folder)}
                                onRename={this.folder.openFolderNameModalRename}
                                onDelete={this.folder.handleDeleteFolder}
                              />
                            ))}
                          {!isMobile &&
                          displayList.length > 0 ? (
                            displayList.map((item, idx) => {
                              const loadingGeneratingQuestions =
                                newGeneratedSurvey &&
                                Array.isArray(newGeneratedSurvey) &&
                                newGeneratedSurvey.includes(item.name) &&
                                !item._id

                              let itm_color =
                                idx % 2 == 0 ? '#ff6233' : '#c6ffe7'

                              if (loadingGeneratingQuestions) {
                                return (
                                  <LayoutRowShadow>
                                    <LayoutData
                                      colWidth={tableCols.name}
                                      className="cursor-pointer trivvy-name-col">
                                      <div
                                        className="d-flex"
                                        data-tip={getTrivvyTitleText(item)}>
                                        <span
                                          className="trivia-list-item-color-chip"
                                          style={{ backgroundColor: itm_color }}
                                        />
                                        <div style={{ flex: 1 }}>
                                          <div
                                            className="survey-item-title survey-item-title-itm"
                                            onClick={() =>
                                              this.redirectToSurveyPage(item)
                                            }>
                                            <span className="survey-item-title">
                                              {getTrivvyTitleText(item)}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <ReactTooltip />
                                    </LayoutData>
                                    <LayoutData>
                                      <div className="text-center">
                                        {' '}
                                        <img
                                          src={Spinner}
                                          height="25px"
                                          width={'25px'}
                                        />{' '}
                                      </div>
                                    </LayoutData>
                                  </LayoutRowShadow>
                                )
                              } else {
                                return (
                                  <LayoutRowShadow
                                    key={idx}
                                    draggable={
                                      isAdmin &&
                                      !showTrivvyListOnly &&
                                      !!item._id
                                    }
                                    onDragStart={(e) =>
                                      this.folder.handleTrivvyDragStart(e, item._id)
                                    }
                                    onDragEnd={this.folder.handleTrivvyDragEnd}
                                    onMouseEnter={() =>
                                      this.setState({ hoveredSurvey: item._id })
                                    }
                                    onMouseLeave={() =>
                                      this.setState({ hoveredSurvey: null })
                                    }
                                    className={
                                      hoveredSurvey == item._id
                                        ? 'pink-border trivvy-draggable-row'
                                        : 'trivvy-draggable-row'
                                    }>
                                    <LayoutData
                                      colWidth={tableCols.name}
                                      className="cursor-pointer trivvy-name-col">
                                      <div className="d-flex trivvy-tbl-list-row-name-col">
                                        <div>
                                          {isAdmin && (
                                            <CheckBox
                                              checked={selectedTrivvys.includes(
                                                item._id
                                              )}
                                              className="mr-2"
                                              onChange={(e) => {
                                                this.handleTrivvyRowCheckboxClick(
                                                  e.target.checked,
                                                  item._id
                                                )
                                              }}
                                            />
                                          )}
                                          {item.averageSentimentsScore &&
                                            item.averageSentimentsScore
                                              .sentiment &&
                                            item.averageSentimentsScore.sentiment
                                              .length ? (
                                            <div
                                              className=""
                                              data-tip={
                                                'Trivvy contains a sentiment analysis'
                                              }>
                                              <TiChartLine size={13} />
                                              <ReactTooltip />
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </div>

                                        <ListRowIcon />

                                        <span
                                          style={{ display: 'block' }}
                                          className="survey-item-title d-block"
                                          onClick={() =>
                                            this.redirectToSurveyPage(item)
                                          }
                                          data-tip={getTrivvyTitleText(item)}>
                                          <span className="survey-item-name-text">
                                            {getTrivvyTitleText(item)}
                                          </span>

                                          <TrivvyPrivacyTag
                                            visibility={item.adminVisibility}
                                          />
                                          <ReactTooltip />
                                        </span>
                                      </div>

                                      {/* {hoveredSurvey == item._id && (
                                        <Button
                                          className="hover-survey-button-position trivia-action-button-main"
                                          onClick={() =>
                                            this.redirectToSurveyPage(item)
                                          }>
                                          Edit
                                        </Button>
                                      )} */}
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center status-cell"
                                      colWidth={tableCols.status}>
                                      {moment(
                                        item.trivvyEndDate
                                      ).isSameOrBefore(moment(), 'day') ? (
                                        <Badge color="secondary">Ended</Badge>
                                      ) : item.isPublished &&
                                        item.scheduledDate &&
                                        moment(item.scheduledDate).isAfter(
                                          moment()
                                        ) ? (
                                        <Badge color="info">Scheduled</Badge>
                                      ) : item.isPublished ? (
                                        <Badge color="success">Published</Badge>
                                      ) : (
                                        <Badge color="warning">
                                          Unpublished
                                        </Badge>
                                      )}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center created-cell"
                                      colWidth={tableCols.createdOn}>
                                      {' '}
                                      <div className="survey-createddate-text">
                                        <SentScheduledCell item={item} isMobile={false} />
                                      </div>
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center questions-cell"
                                      colWidth={tableCols.questions}>
                                      {' '}
                                      <div
                                        data-tip="View content"
                                        onClick={() =>
                                          this.redirectToSurveyPage(item)
                                        }
                                      // className="trivia-action-button-secondary-center"
                                      >
                                        {' '}
                                        {hasQuestions(item)
                                          ? item.questions.length
                                          : <span className="list-empty-dash">&mdash;</span>}{' '}
                                        <ReactTooltip />
                                      </div>
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center sent-cell"
                                      colWidth={tableCols.sent}>
                                      {getSentCount(item)}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center waiting_text responses-cell"
                                      colWidth={tableCols.responses}>
                                      {getResponsesCountSurvey(item)}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center response-rate-cell"
                                      colWidth={tableCols.responseRate}>
                                      {hasResponseRate(item)
                                        ? Math.round(getResponseRate(item, getResponsesCountSurvey(item)) * 100) + '%'
                                        : <span className="list-empty-dash">&mdash;</span>}
                                    </LayoutData>

                                    <LayoutData
                                      className="text-center scheduled-cell"
                                      colWidth={tableCols.scheduledOn}>
                                      {item.needsAttentionCount || 0}
                                    </LayoutData>
                                    <LayoutData
                                      className="text-center"
                                      colWidth={tableCols.action}>
                                      {this.renderRowOptions(item)}
                                    </LayoutData>
                                  </LayoutRowShadow>
                                )
                              }
                            })
                          ) : isSortReloading ? (
                            <LayoutRowShadow>
                              <LayoutData colWidth={12}>
                                <ListLoadingRow />
                              </LayoutData>
                            </LayoutRowShadow>
                          ) : showEmptyMessage ? (
                            <LayoutRowShadow>
                              {' '}
                              <LayoutData colWidth={12}>
                                {' '}
                                <div className="folder-empty-message">
                                  {this.state.isSearchActive
                                    ? 'No results found'
                                    : emptyMessageText}
                                </div>{' '}
                              </LayoutData>{' '}
                            </LayoutRowShadow>
                          ) : (
                            ''
                          )}
                        </div>
                      )}
                    </BottomScrollListener>
                  </div>
                </div>
              </div>
            ) : (
              <div className="trivia_table_mobile mt-4">
                <div className="trivia-mobile-header-wrap">
                <Row className="trivia-mobile-table-header mx-0">
                  <Col xs={5} className="px-0">
                    <LayoutHeadingShadow
                      className={'bwai-mobile-name-heading'}
                      colWidth={12}>
                      {isAdmin && (
                        <CheckBox
                          checked={
                            displayList.length > 0 &&
                            selectedTrivvys.length === displayList.length
                          }
                          onChange={(e) =>
                            this.handleSelectAllTrivvys(e.target.checked)
                          }
                          className="mr-2"
                        />
                      )}
                      Name {this.sortComponent('name')}{' '}
                    </LayoutHeadingShadow>
                  </Col>

                  <Col
                    xs={7}
                    className="scrollable-action-table-row trivia-mobile-header-scroll px-0"
                    onScroll={(e) => {
                      const container = e.target.closest('.trivia_table_mobile')
                      if (!container) return
                      const bodyEl = container.querySelector(
                        '.trivia_survey_list_table_contents_scroll .scrollable-action-table-row'
                      )
                      if (bodyEl && bodyEl.scrollLeft !== e.target.scrollLeft) {
                        bodyEl.scrollLeft = e.target.scrollLeft
                      }
                    }}>
                    <LayoutRowLines className="row-scroll-width-s">
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.status}>
                        Status {this.sortComponent('status')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.createdOn}>
                        Send Date {this.sortComponent('createdDate')}
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.questions}>
                        Questions {this.sortComponent('questionsCount')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.sent}>
                        Sent {this.sortComponent('sent')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.responses}>
                        Responses{' '}
                        {this.sortComponent('submissions')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.responseRate}>
                        {TRIVVY_LIST_COLUMN_LABELS.RATE}{' '}
                        {this.sortComponent('responseRate')}
                      </LayoutHeadingShadow>
                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={tableColsMobile.scheduledOn}>
                        {TRIVVY_LIST_COLUMN_LABELS.ATTENTION}{' '}
                        {this.sortComponent('needsAttentionCount')}
                      </LayoutHeadingShadow>

                      <LayoutHeadingShadow
                        className={'justify-content-center '}
                        colWidth={
                          tableColsMobile.action
                        }></LayoutHeadingShadow>
                    </LayoutRowLines>
                  </Col>
                </Row>
                </div>

                <BottomScrollListener
                  onBottom={
                    this.state.isSearchActive
                      ? this.handleSearchScrollBottom
                      : this.handleBottomScroll
                  }>
                  {(scrollRef) => (
                    <div
                      className="trivia_survey_list_table_contents_scroll"
                      ref={scrollRef}>
                      {isSortReloading ? (
                        <ListLoadingRow isMobile />
                      ) : showEmptyMessage ? (
                        <div className="folder-empty-message folder-empty-message-mobile mx-0">
                          {this.state.isSearchActive
                            ? 'No results found'
                            : emptyMessageText}
                        </div>
                      ) : (
                        ''
                      )}
                      <Row className="mx-0">
                        <Col xs={5} className="px-0">
                          {showFolders &&
                            sortedFolders.map((folder) => (
                              <FolderRowMobileLines
                                key={folder._id}
                                half="name"
                                folder={folder}
                                itemCount={folderService.getFolderItemCount(
                                  folderMembership,
                                  folder._id
                                )}
                                itemNoun={folderService.getFolderNoun(
                                  this.folder.category
                                )}
                                onOpen={() => this.folder.openFolder(folder)}
                              />
                            ))}
                          {displayList.map((item, idx) => {
                            return (
                              <LayoutRowLines
                                key={idx}
                                className={
                                  'planning-row-mobile-height mx-0 px-0'
                                }>
                                <LayoutDataLines
                                  colWidth={12}
                                  noFlex
                                  className="d-flex align-items-center bwai-mobile-name-cell">
                                  {isAdmin && (
                                    <CheckBox
                                      checked={selectedTrivvys.includes(
                                        item._id
                                      )}
                                      className="mr-2"
                                      onClick={(e) => e.stopPropagation()}
                                      onChange={(e) => {
                                        e.stopPropagation()
                                        this.handleTrivvyRowCheckboxClick(
                                          e.target.checked,
                                          item._id
                                        )
                                      }}
                                    />
                                  )}
                                  <ListRowIcon />
                                  <div
                                    onClick={() =>
                                      this.redirectToSurveyPage(item)
                                    }
                                    className="cursor-pointer">
                                    <div
                                      className="survey-item-title-itm"
                                      data-tip={getTrivvyTitleText(item)}>
                                      <span className="survey-item-title">
                                        {getTrivvyTitleText(item)}
                                      </span>
                                      <TrivvyPrivacyTag
                                        visibility={item.adminVisibility}
                                      />
                                    </div>
                                    <ReactTooltip />
                                  </div>
                                  <ReactTooltip />
                                </LayoutDataLines>
                              </LayoutRowLines>
                            )
                          })}
                        </Col>

                        <Col
                          xs={7}
                          className="scrollable-action-table-row px-0"
                          onScroll={(e) => {
                            const container = e.target.closest('.trivia_table_mobile')
                            if (!container) return
                            const headerEl = container.querySelector(
                              '.trivia-mobile-table-header .scrollable-action-table-row'
                            )
                            if (headerEl && headerEl.scrollLeft !== e.target.scrollLeft) {
                              headerEl.scrollLeft = e.target.scrollLeft
                            }
                          }}>
                          {showFolders &&
                            sortedFolders.map((folder) => (
                              <FolderRowMobileLines
                                key={folder._id}
                                half="data"
                                folder={folder}
                                isAdmin={isAdmin}
                                dataColWidths={[
                                  tableColsMobile.status,
                                  tableColsMobile.createdOn,
                                  tableColsMobile.questions,
                                  tableColsMobile.sent,
                                  tableColsMobile.responses,
                                  tableColsMobile.responseRate,
                                  tableColsMobile.scheduledOn,
                                ]}
                                actionColWidth={tableColsMobile.action}
                                onOpen={() => this.folder.openFolder(folder)}
                                onRename={this.folder.openFolderNameModalRename}
                                onDelete={this.folder.handleDeleteFolder}
                              />
                            ))}
                          {displayList.map((item, idx) => {
                            return (
                              <LayoutRowLines
                                key={idx}
                                className={`pl-tasks-row ${
                                  isMobile ? 'row-scroll-width-s' : ''
                                }`}>
                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.status}>
                                  {moment(item.trivvyEndDate).isSameOrBefore(
                                    moment(),
                                    'day'
                                  ) ? (
                                    <Badge color="secondary">Ended</Badge>
                                  ) : item.isPublished &&
                                    item.scheduledDate &&
                                    moment(item.scheduledDate).isAfter(
                                      moment()
                                    ) ? (
                                    <Badge color="info">Scheduled</Badge>
                                  ) : item.isPublished ? (
                                    <Badge color="success">Published</Badge>
                                  ) : (
                                    <Badge color="warning">Unpublished</Badge>
                                  )}
                                </LayoutDataLines>

                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.createdOn}>
                                  {' '}
                                  <div className="survey-createddate-text text-info">
                                    <SentScheduledCell item={item} isMobile={true} />
                                  </div>
                                </LayoutDataLines>
                                <LayoutDataLines
                                  colWidth={tableColsMobile.questions}
                                  className="text-center font-13px">
                                  {hasQuestions(item)
                                    ? item.questions.length
                                    : <span className="list-empty-dash">&mdash;</span>}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  className="text-center font-13px"
                                  colWidth={tableColsMobile.sent}>
                                  {getSentCount(item)}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  className="text-center py-1 font-13px waiting_text"
                                  colWidth={tableColsMobile.responses}>
                                  {getResponsesCountSurvey(item)}
                                </LayoutDataLines>
                                <LayoutDataLines
                                  className="text-center py-1 font-13px"
                                  colWidth={tableColsMobile.responseRate}>
                                  {hasResponseRate(item)
                                    ? Math.round(getResponseRate(item, getResponsesCountSurvey(item)) * 100) + '%'
                                    : <span className="list-empty-dash">&mdash;</span>}
                                </LayoutDataLines>

                                <LayoutDataLines
                                  colWidth={tableColsMobile.scheduledOn}
                                  className="text-center font-13px">
                                  {item.needsAttentionCount || 0}
                                </LayoutDataLines>

                              

                                <LayoutDataLines
                                  colWidth={tableColsMobile.action}
                                  className="text-center">
                                  {this.renderRowOptions(item)}
                                </LayoutDataLines>
                              </LayoutRowLines>
                            )
                          })}
                        </Col>
                      </Row>
                    </div>
                  )}
                </BottomScrollListener>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    sortParams:
      state.sortFilterParams && state.sortFilterParams.triviaList
        ? state.sortFilterParams.triviaList.sort &&
          state.sortFilterParams.triviaList.sort.hasOwnProperty('sortBy')
          ? state.sortFilterParams.triviaList.sort
          : { sortBy: '', sortOrder: '' }
        : { sortBy: '', sortOrder: '' },

    importTemplateAddedTrivvys: state.trivia.importTemplateAddedTrivvys,
    showCreatePopup: state.trivia.showCreatePopup,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    updateSortParams: (data) => dispatch(actionCreators.updateTriviaSort(data)),
    setImportTemplateAddedTrivvys: (data) =>
      dispatch(actionCreators.setImportTemplateAddedTrivvys(data)),

    handleGlobalRewardModal: (data) =>
      dispatch(actionCreators.handleGlobalRewardModal(data)),
    setCreateModalState: (data) =>
      dispatch(actionCreators.setCreateModalState(data)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaList, axios))
